import PropTypes from 'prop-types';

// Utils
import { cn } from '@repo/zolintra-utils';

// Styles
import styles from './Toast.module.css';

// Components
import { Icon } from '../Icon/Icon';

const icon = {
  success: 'tickCircle',
  alert: 'danger',
  info: 'infoCircle',
};

export function Toast({
  type, hasIcon, hasCross, children,
}) {
  return (
    <div className={cn([styles.container, styles[type]])}>
      <div className={styles.content}>
        {hasIcon ? <Icon icon={icon[type]} className={styles.icon} /> : null}
        {children}
      </div>
      {hasCross ? <Icon icon="cross" className={styles.close} /> : null}
    </div>
  );
}

Toast.propTypes = {
  type: PropTypes.oneOf(['success', 'alert', 'info']),
  hasIcon: PropTypes.bool,
  hasCross: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

Toast.defaultProps = {
  type: 'info',
  hasIcon: true,
  hasCross: false,
};

export default Toast;
